// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","5514":"20eaef7d","5969":"570f2b94","7692":"220ec4c0","7820":"aa7793e6","9266":"220ec4c0"}[chunkId] + ".chunk.css";
};